export const FAILED_REFRESHED_TOKEN_ERROR_CAUSE = 'failed to refresh token.';
